import emInput from './emapComponents/emInput.vue';
import emTextarea from './emapComponents/emTextarea.vue';
import emSelect from './emapComponents/emSelect.vue';
import emSwitcher from './emapComponents/emSwitcher.vue';
import emDateTimePicker from './emapComponents/emDateTimePicker.vue';
import emSelectlist from './emapComponents/emSelectlist.vue';
import emUploadImage from './emapComponents/emUploadImage.vue';
import emSelecttable from './emapComponents/emSelecttable.vue';
import emAttachmentList from './emapComponents/emAttachmentList.vue';
import emButtonlist from './emapComponents/emButtonlist.vue';
import emTree from './emapComponents/emTree.vue';
export default {
    'emtext': emInput, 					//文本，
    'emtextarea': emTextarea, 				//文本域
    'emnumber': emInput, 				//数字
    'emselect': emSelect,				//下拉(带搜索功能)
    'emmulti-select': emSelect,			//多选下拉(有复选框)(带搜索功能)
    'emmulti-select2': emSelect,			//多选下拉(旧)(带搜索功能)
    'emswitcher': emSwitcher,			//开关
    'emtime': emDateTimePicker,         //时间
    'emdate-local': emDateTimePicker,	//日期
    'emdate-ym': emDateTimePicker,
    'emdate-full': emDateTimePicker,		//日期及时间
    'emradiolist': emSelectlist,			//单选组
    'emcheckboxlist': emSelectlist,        //多选组
    'emuploadsingleimage': emUploadImage,        //单图片上传
    'emuploadmuiltimage': emUploadImage,        //多图片上传
    'emselecttable': emSelecttable,        //下拉表格
    'emuploadfile': emAttachmentList,        //上传文件（只读）
    'embuttonlist': emButtonlist,        //按钮组
    'emmulti-buttonlist': emButtonlist,        //多选按钮组
    'emmulti-tree': emTree,        //多选下拉树
    'emtree': emTree        //下拉树
};


// WEBPACK FOOTER //
// ./src/components/emapm-form/form-components.js